import { motion } from 'framer-motion'
import { EXPERIENCE_RUNGS } from '../config'

export default function Experience() {
  return (
    <section
      id="experience"
      data-testid="experience-section"
      className="relative bg-[var(--exp-bg)] px-6 py-24 text-[var(--exp-ink)] md:px-12 md:py-32"
    >
      <div className="mx-auto max-w-6xl">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <h2 className="font-display max-w-lg text-5xl font-semibold leading-[0.95] tracking-tight md:text-6xl">
            The climb
            <br />
            so far.
          </h2>
          <p className="max-w-xs text-sm text-[var(--exp-ink)]/60">
            Three rungs up so far — one live production system, two ventures built
            solo, two national hackathon podiums.
          </p>
        </div>

        {/* the ladder */}
        <div className="relative mt-16 md:mt-20">
          <div
            className="absolute left-1/2 top-0 hidden h-full w-[3px] -translate-x-1/2 md:block"
            style={{
              background:
                'repeating-linear-gradient(to bottom, var(--exp-ink) 0, var(--exp-ink) 10px, transparent 10px, transparent 20px)',
              opacity: 0.25,
            }}
          />

          <div className="flex flex-col gap-14 md:gap-6">
            {EXPERIENCE_RUNGS.map((r, i) => (
              <motion.div
                key={r.step}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.6, delay: i * 0.05 }}
                data-testid={`experience-rung-${i + 1}`}
                className={`relative flex md:items-center ${
                  r.align === 'left' ? 'md:justify-start' : 'md:justify-end'
                }`}
              >
                <div
                  className="w-full rounded-[28px] p-8 shadow-[6px_6px_0_rgba(22,19,15,0.9)] md:w-[46%]"
                  style={{ background: r.color }}
                >
                  <div className="flex items-center justify-between">
                    <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-black/60">
                      {r.step}
                    </span>
                    <span className="font-mono text-[11px] text-black/60">{r.period}</span>
                  </div>
                  <h3 className="font-display mt-4 text-2xl font-semibold md:text-3xl">
                    {r.title}
                  </h3>
                  <p className="mt-1 text-sm font-medium text-black/70">{r.org}</p>
                  <ul className="mt-5 space-y-2.5">
                    {r.points.map((p) => (
                      <li key={p} className="flex gap-2.5 text-sm leading-relaxed text-black/80">
                        <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-black/50" />
                        {p}
                      </li>
                    ))}
                  </ul>
                  {r.links && (
                    <div className="mt-5 flex flex-wrap gap-2">
                      {r.links.map((l) => (
                        <a
                          key={l.href}
                          href={l.href}
                          target="_blank"
                          rel="noreferrer"
                          data-testid={`experience-link-${l.label.split('.')[0]}`}
                          className="font-mono rounded-full bg-black/15 px-3 py-1.5 text-[11px] font-semibold text-black/80 transition hover:bg-black/25"
                        >
                          {l.label} ↗
                        </a>
                      ))}
                    </div>
                  )}
                </div>
              </motion.div>
            ))}
          </div>

          {/* the next rung */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="relative mt-14 flex flex-col items-center gap-3 text-center md:mt-20"
          >
            <span className="font-mono text-[11px] uppercase tracking-[0.25em] text-black/50">
              Next rung
            </span>
            <div
              data-testid="experience-next-rung"
              className="rounded-full px-8 py-4 shadow-[6px_6px_0_rgba(22,19,15,0.9)]"
              style={{ background: 'var(--exp-yellow)' }}
            >
              <span className="font-display text-lg font-semibold md:text-xl">
                You — hiring me next.
              </span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  )
}
